import { Tooltip } from '@chakra-ui/react';
import { useState } from 'react';

export const TooltipComponent = ({
  description,
  Icon,
  className,
  onClick,
  maxW = 300,
  color,
  placement,
  fontSize,
  distance,
  children
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsTooltipOpen(true);
  };

  const handleMouseLeave = () => {
    setIsTooltipOpen(false);
  };

  const parseDistance = (d) => {
    if (typeof d === 'number') return d;
    if (typeof d === 'string') {
      const m = d.match(/(-?\d+)/);
      if (m) return parseInt(m[0], 10);
    }
    if (d && typeof d === 'object') {
      // support object like { base: '155px', md: '0' } by taking base
      const val = d.base || Object.values(d)[0];
      return parseDistance(val);
    }
    return undefined;
  };

  const numericDistance = parseDistance(distance);
  const popperModifiers = [
    { name: 'preventOverflow', options: { padding: 8 } },
    {
      name: 'flip',
      options: { fallbackPlacements: ['top', 'bottom', 'right', 'left'], padding: 8 }
    },
    { name: 'offset', options: { offset: numericDistance ? [0, numericDistance] : [0, 8] } }
  ];

  return (
    <Tooltip
      rounded="0.75rem"
      label={description}
      placement={placement || 'top-start'}
      zIndex={0}
      bg="#E6E7EB"
      p={{ base: '10px', md: '1rem' }}
      popperProps={{ modifiers: popperModifiers }}
      fontSize={fontSize || 'xs'}
      w={'fit-content'}
      color={color || '#333333'}
      isOpen={isTooltipOpen && description}
      isDisabled={!description}
      maxW={maxW}
    >
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={children ? 'w-full' : 'flex items-center gap-1'}
      >
        {Icon && (
          <img
            src={Icon}
            cursor="pointer"
            className={`w-4 h-4 z-0 ${className}`}
            alt=""
            onClick={onClick}
          />
        )}
        {children}
      </div>
    </Tooltip>
  );
};
